// src/Auth.ts
import { PrefixV2, b58Encode } from "@taquito/utils";
import CustomAuth from "@toruslabs/customauth";
var WEB3_AUTH_CLIENT_ID = "BBQoFIabI50S1-0QsGHGTM4qID_FDjja0ZxIxKPyFqc0El--M-EG0c2giaBYVTVVE6RC9WCUzCJyW24aJrR_Lzc";
var Auth = class {
  /* istanbul ignore next */
  async getTorusClient() {
    const torus = new CustomAuth({
      web3AuthClientId: WEB3_AUTH_CLIENT_ID,
      baseUrl: "https://auth.umamiwallet.com/",
      redirectPathName: "redirect.html",
      // Hack to enable reusing of the single redirect.html across different surfaces (e.g., desktop, mobile, embed).
      // The 'redirectToOpener' is originally designed to accept a boolean value to control redirect behavior.
      redirectToOpener: window.location.origin,
      uxMode: "popup",
      network: "mainnet"
    });
    await torus.init({ skipSw: true });
    return torus;
  }
  async getCredentials() {
    const loginResult = await this.login();
    const privateKey = loginResult.finalKeyData.privKey || loginResult.oAuthKeyData.privKey;
    const secretKey = b58Encode(privateKey, PrefixV2.Secp256k1SecretKey);
    const userInfo = Array.isArray(loginResult.userInfo) ? loginResult.userInfo[0] : loginResult.userInfo;
    return {
      secretKey,
      id: userInfo.verifierId || userInfo.name,
      name: userInfo.name,
      email: userInfo.email,
      imageUrl: userInfo.profileImage
    };
  }
};

// src/parseTorusRedirectParams.ts
var parseTorusRedirectParams = (url) => {
  const params = new URLSearchParams(url.replace("umami://auth/", ""));
  const instanceParams = {
    instanceId: params.get("instanceId"),
    verifier: params.get("verifier"),
    typeOfLogin: params.get("typeOfLogin"),
    redirectToOpener: params.get("redirectToOpener")
  };
  const hashParams = {
    state: params.get("state"),
    access_token: params.get("access_token"),
    token_type: params.get("token_type"),
    expires_in: params.get("expires_in"),
    scope: params.get("scope"),
    id_token: params.get("id_token"),
    authuser: params.get("authuser"),
    hd: params.get("hd"),
    prompt: params.get("prompt")
  };
  const data = { instanceParams, hashParams };
  const result = {
    channel: params.get("channel"),
    data,
    error: params.get("error")
  };
  return result;
};

// src/constants.ts
var JWT_AUTH_DOMAIN = "https://kukai.eu.auth0.com";

// src/EmailAuth.ts
var EmailAuth = class extends Auth {
  clientId = "LTg6fVsacafGmhv14TZlrWF1EavwQoDZ";
  idpName = "email";
  async login() {
    const client = await this.getTorusClient();
    return client.triggerAggregateLogin({
      verifierIdentifier: "tezos-google",
      aggregateVerifierType: "single_id_verifier",
      subVerifierDetailsArray: [
        {
          verifier: "web-kukai-email",
          typeOfLogin: "jwt",
          clientId: this.clientId,
          jwtParams: {
            connection: "",
            verifierIdField: "name",
            domain: JWT_AUTH_DOMAIN
          }
        }
      ]
    });
  }
};

// src/FacebookAuth.ts
var FacebookAuth = class extends Auth {
  idpName = "facebook";
  clientId = "523634882377310";
  async login() {
    const client = await this.getTorusClient();
    return client.triggerLogin({
      verifier: "tezos-facebook",
      clientId: this.clientId,
      typeOfLogin: "facebook",
      jwtParams: {
        scope: "public_profile email"
      }
    });
  }
};

// src/GoogleAuth.ts
var GoogleAuth = class extends Auth {
  idpName = "google";
  clientId = "1070572364808-d31nlkneam5ee6dr0tu28fjjbsdkfta5.apps.googleusercontent.com";
  async login() {
    const client = await this.getTorusClient();
    return client.triggerAggregateLogin({
      verifierIdentifier: "tezos-google",
      aggregateVerifierType: "single_id_verifier",
      subVerifierDetailsArray: [
        {
          clientId: this.clientId,
          typeOfLogin: "google",
          verifier: "umami"
        }
      ]
    });
  }
};

// src/RedditAuth.ts
var RedditAuth = class extends Auth {
  idpName = "reddit";
  clientId = "zyQ9tnKfdg3VNyj6MGhZq4dHbBzbmEvl";
  async login() {
    const client = await this.getTorusClient();
    return client.triggerAggregateLogin({
      verifierIdentifier: "tezos-reddit",
      aggregateVerifierType: "single_id_verifier",
      subVerifierDetailsArray: [
        {
          verifier: "web-kukai",
          typeOfLogin: "jwt",
          clientId: this.clientId,
          jwtParams: {
            connection: "Reddit",
            verifierIdField: "name",
            domain: JWT_AUTH_DOMAIN
          }
        }
      ]
    });
  }
};

// src/TwitterAuth.ts
var TwitterAuth = class extends Auth {
  idpName = "twitter";
  clientId = "3aCoxh3pw8g8JeFsdlJNUGwdgtLwdwgE";
  async login() {
    const client = await this.getTorusClient();
    return client.triggerLogin({
      verifier: "tezos-twitter",
      clientId: this.clientId,
      typeOfLogin: "twitter",
      jwtParams: {
        domain: JWT_AUTH_DOMAIN
      }
    });
  }
};

// src/forIDP.ts
var forIDP = (idp) => {
  switch (idp) {
    case "google":
      return new GoogleAuth();
    case "email":
      return new EmailAuth();
    case "reddit":
      return new RedditAuth();
    case "facebook":
      return new FacebookAuth();
    case "twitter":
      return new TwitterAuth();
    case "apple":
      throw new Error("Apple Auth is not supported yet");
  }
};
export {
  Auth,
  FacebookAuth,
  JWT_AUTH_DOMAIN,
  forIDP,
  parseTorusRedirectParams
};
